import React, { useEffect, useState } from 'react';

import Icone from './Icone';
/**
 * PWA Install Banner — Sprint 5.18 (2026-05-24).
 *
 * Aparece sutil no rodape quando:
 *  - Browser suporta install prompt (Android Chrome)
 *  - Usuario nao instalou ainda (verifica via localStorage flag)
 *
 * No iOS Safari nao tem API de install. Mostra instrucao "Compartilhar →
 * Adicionar à Tela Inicial" se detectar iPhone/iPad.
 */
export default function PwaInstallBanner() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [mostrar, setMostrar] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    const dispensado = localStorage.getItem('pwa-install-dispensado');
    if (dispensado) return;

    // Detecta iOS
    const ios = /iPhone|iPad|iPod/.test(navigator.userAgent) && !window.MSStream;
    const standaloneIOS = window.navigator.standalone;  // ja instalou no iOS
    if (ios && !standaloneIOS) {
      setIsIOS(true);
      setMostrar(true);
      return;
    }

    // Android/Chrome — beforeinstallprompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setMostrar(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const instalar = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const escolha = await deferredPrompt.userChoice;
    if (escolha.outcome === 'accepted') {
      localStorage.setItem('pwa-install-dispensado', '1');
    }
    setDeferredPrompt(null);
    setMostrar(false);
  };

  const dispensar = () => {
    localStorage.setItem('pwa-install-dispensado', '1');
    setMostrar(false);
  };

  if (!mostrar) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: 16,
        left: '50%',
        transform: 'translateX(-50%)',
        // Abaixo da gaveta do menu (z 55/60) e com largura própria: com left 50%
        // a caixa encolhia pra metade da tela e o texto quebrava palavra a palavra.
        zIndex: 50,
        width: 'min(380px, calc(100vw - 24px))',
        boxSizing: 'border-box',
        padding: '12px 16px',
        background: 'var(--glass-bg-strong)',
        backdropFilter: 'blur(20px) saturate(160%)',
        border: '1px solid var(--glass-border-strong)',
        borderRadius: 12,
        boxShadow: 'var(--glass-shadow-lg)',
        display: 'flex',
        gap: 10,
        alignItems: 'center',
      }}
    >
      <span style={{ fontSize: 24 }}><Icone nome="celular" tamanho={30} espessura={1.5} /></span>
      <div style={{ flex: 1, fontSize: 12 }}>
        {isIOS ? (
          <>
            <div style={{ fontWeight: 600, color: 'var(--text)' }}>Adicione o Cockpit à tela inicial</div>
            <div style={{ color: 'var(--text-muted)', marginTop: 2 }}>
              Toque em <strong>⎙ Compartilhar</strong> → <strong>"Adicionar à Tela de Início"</strong>
            </div>
          </>
        ) : (
          <>
            <div style={{ fontWeight: 600, color: 'var(--text)' }}>Instalar Cockpit Marçal</div>
            <div style={{ color: 'var(--text-muted)', marginTop: 2 }}>Acesso rápido como app nativo</div>
          </>
        )}
      </div>
      {!isIOS && (
        <button className="btn btn-sm btn-primary" onClick={instalar} style={{ fontSize: 11 }}>Instalar</button>
      )}
      <button onClick={dispensar} style={{
        background: 'none', border: 'none', color: 'var(--text-muted)', fontSize: 18, cursor: 'pointer', padding: 4,
      }} title="Dispensar">✕</button>
    </div>
  );
}
